"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebChatPopUp = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var services_1 = require("@falcon/services");
var WebChatPopUp = /** @class */ (function (_super) {
    __extends(WebChatPopUp, _super);
    function WebChatPopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadWebChatScript = function () {
            if (_this.props.policyNumber) {
                var value = services_1.resourcesHelper.THEME === "Britannia" ? "motor" : (0, commonFunctions_1.getWebChatScriptValueByPolicyNumber)(_this.props.policyNumber);
                if (value) {
                    var provider = _this.isContentGuruEnabled() ? "content-guru" : "genesys";
                    var scriptPath = "/".concat(provider, "-web-chat-script-").concat(value, ".js");
                    // Check if the script is already loaded
                    if (!document.querySelector("script[src=\"".concat(scriptPath, "\"]"))) {
                        var script = document.createElement("script");
                        script.src = scriptPath;
                        script.async = true;
                        if (provider === "genesys") {
                            script.onload = function () {
                                if (typeof window.Genesys === "function") {
                                    window.Genesys("init");
                                }
                                else {
                                    console.error("Genesys is not defined in the local script.");
                                }
                            };
                        }
                        document.head.appendChild(script);
                    }
                }
            }
        };
        return _this;
    }
    WebChatPopUp.prototype.componentDidMount = function () {
        this.loadWebChatScript();
    };
    WebChatPopUp.prototype.render = function () {
        // No UI components to render, only loading script
        return null;
    };
    WebChatPopUp.prototype.isContentGuruEnabled = function () {
        return process.env.REACT_APP_CONTENT_GURU_ENABLED ? JSON.parse(process.env.REACT_APP_CONTENT_GURU_ENABLED) : false;
    };
    ;
    return WebChatPopUp;
}(React.Component));
exports.WebChatPopUp = WebChatPopUp;
//# sourceMappingURL=WebChatPopUp.js.map